import { withTranslation } from 'react-i18next'
import Employees from './Employees'

export default withTranslation()(Employees)
